module.exports = __webpack_public_path__ + "static/media/icon-rar.6808aad9.svg";